import { createDivIn, createImgIn, createParagraphIn, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { AudioManager, AudioType } from '@colonist/audio';
export class UIComponentDropdownController {
    createDropdownContent(dropdownContent) {
        this.dropdownView.replaceChildren();
        dropdownContent.forEach((content)=>{
            this.createDropdownContentElement(content);
        });
    }
    createDropdownContentElement(content) {
        const dropdownContentContainer = createDivIn(this.dropdownView, '', content.id);
        if (content.icon != undefined) createImgIn(dropdownContentContainer, content.icon);
        createParagraphIn(dropdownContentContainer, content.text, content.class);
        setElementOnClick(dropdownContentContainer, ()=>{
            if (content.class.includes('component-dropdown-disabled')) return;
            if (content.action != undefined) content.action();
            this.hideDropdownMenuIfShown();
        }, true);
    }
    dropdownButtonAction() {
        AudioManager.play(AudioType.Click);
        this.dropdownView.classList.toggle('show');
    }
    hideDropdownMenuIfShown() {
        const dropDownViewShown = this.dropdownView.classList.contains('show');
        if (!dropDownViewShown) return;
        this.dropdownView.classList.toggle('show');
    }
    updateDropdownState(dropdownContent) {
        var _this_dropdownView;
        if (((_this_dropdownView = this.dropdownView) === null || _this_dropdownView === void 0 ? void 0 : _this_dropdownView.replaceChildren) == undefined) return;
        this.dropdownView.replaceChildren();
        this.createDropdownContent(dropdownContent);
    }
    constructor(dropdownContent, dropdownParentId, hideDropdown, toggleVisibilityComponent){
        const dropdownContainers = document.getElementsByClassName('component-dropdown-container');
        for (const dropdownContainer of dropdownContainers){
            const parent = dropdownContainer.parentElement;
            if (parent.id == dropdownParentId) {
                this.dropdownContainer = dropdownContainer;
                this.dropdownButton = toggleVisibilityComponent;
                this.dropdownView = this.dropdownContainer.children[1];
            }
        }
        if (hideDropdown) {
            this.dropdownContainer.style.display = 'none';
            return;
        }
        this.dropdownContainer.style.display = 'inline-block';
        if (this.dropdownButton == undefined) return;
        if (this.dropdownView == undefined) return;
        this.createDropdownContent(dropdownContent);
        setElementOnClick(this.dropdownButton, (event)=>{
            const target = event.target;
            const targetInsideDropdownView = this.dropdownView.contains(target);
            if (targetInsideDropdownView) return;
            this.dropdownButtonAction();
        });
        document.addEventListener('pointerdown', (event)=>{
            const target = event.target;
            const targetInsideContainer = this.dropdownContainer.contains(target);
            const targetInsideToggleContainer = toggleVisibilityComponent.contains(target);
            if (targetInsideContainer) return;
            if (targetInsideToggleContainer) return;
            this.hideDropdownMenuIfShown();
        });
    }
}
